import React from "react";

const ThemeSwitchContext = React.createContext();

export default ThemeSwitchContext;